import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogisticaService } from '../services/logistica.service';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';

@Component({
  selector: 'app-modal-historico-movimientos',
  templateUrl: './modal-historico-movimientos.component.html',
  styleUrls: ['./modal-historico-movimientos.component.scss']
})
export class ModalHistoricoMovimientosComponent implements OnInit {
  historico: any[] = [];
  filtroFecha: string = '';
  displayedColumns: string[] = ['FECHA_EVENTO', 'USUARIO_EVENTO', 'TIPO_EVENTO', 'COD_BODEGA', 'TIPO_SERVICIO', 'FECHA_PICKING', 'ESTADO_APERTURA', 'CIERRE', 'APERTURA'];

  get historicoFiltrado(): any[] {
    if (!this.filtroFecha) return this.historico;
    return this.historico.filter(item => {
      const fechaPicking = item.FECHA_PICKING ? String(item.FECHA_PICKING).substring(0, 10) : '';
      return fechaPicking === this.filtroFecha;
    });
  }

  constructor(
    public dialogRef: MatDialogRef<ModalHistoricoMovimientosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logisticaService: LogisticaService,
    private notificationService: NotificationHelper
  ) {}

  async ngOnInit(): Promise<void> {
    await this.cargarHistorico();
  }

  async cargarHistorico(): Promise<void> {
    showSpinner();
    try {
      const response = await this.logisticaService.obtenerHistorialMovimientos(this.data.idPoligono);
      if (response && response.success) {
        this.historico = response.data;
      } else {
        this.notificationService.errorMessage('Error', 'No se pudo cargar los movimientos');
      }
    } catch (error) {
      console.error('Error al cargar movimientos:', error);
      this.notificationService.errorMessage('Error', 'Ocurrió un error al cargar los movimientos');
    } finally {
      hideSpinner();
    }
  }

  getEstadoLabel(estado: string): string {
    return estado === 'C' ? 'Cerrado' : estado === 'A' ? 'Abierto' : (estado || 'N/A');
  }

  getEventoLabel(tipo: string): string {
    return tipo === 'INSERT' ? 'Creación' : tipo === 'UPDATE' ? 'Actualización' : tipo === 'DELETE' ? 'Eliminación' : (tipo || '-');
  }

  // Un cierre/apertura de polígono registra 1 fila del polígono completo (OPs + servicios)
  // y 1 fila por cada tipo de servicio; TIPO_SERVICIO las distingue.
  getTipoServicio(item: any): string {
    return item.TIPO_SERVICIO_MON || item.TIPO_SERVICIO || '';
  }

  getTipoServicioLabel(tipo: string): string {
    const labels: { [k: string]: string } = {
      CAM: 'Cambio Total',
      CAP: 'Cambio Parcial',
      TAR: 'Taller Recogida',
      TAE: 'Taller Entrega',
      DEV: 'Devolución',
      NTC: 'Nota Crédito'
    };
    return tipo ? (labels[tipo] || tipo) : 'Polígono completo (OPs)';
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
